import "../main.css";

export default function MenuInicioRapido() {
  return (
    <div>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        <li className="nav-item open">
          <h4>Comece Aqui</h4>

          <ul className="nav nav-pills flex-column">
            <li className="nav-item">
              <a
                className="nav-link"
                href="/como-conectar-minha-conta-do-facebook-ou-instagram"
              >
                Como conectar minha conta do Facebook ou Instagram?
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/como-enriquecer-meus-dados">
                Como enriquecer meus dados?
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
